export const initialData = {
  nome: '',
  min_valor: '0.0',
  max_valor: '10.0',
}
export default initialData;
